'use client';

import { useRef } from 'react';
import { motion } from 'framer-motion';
import { montserratMedium } from '@/app/fonts';
import { Link } from '@/i18n/routing';

interface FizzyButtonProps {
  onClick?: () => void;
  href?: string;
  text?: string;
  className?: string;
}

const buttonContent = (
  text: string,
  className: string
) => (
  <>
    <motion.div 
      className="button-icon"
      variants={{
        initial: { x: '-50%', y: 0, opacity: 0 },
        hover: { x: 'calc(-50% - 34px)', y: 0, opacity: 1 }
      }}
      transition={{ duration: 0.3, delay: 0.1 }}
    >
      <svg 
        width="25" 
        height="25" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3" 
          stroke="#0b71ff" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </motion.div>
    <motion.span
      className={`${montserratMedium.className} button-text text-sm`}
      variants={{
        initial: { x: '-50%' },
        hover: { x: 'calc(-50% + 20px)' }
      }}
      transition={{ duration: 0.4, delay: 0.1 }}
    >
      {text}
    </motion.span>
  </>
);

export default function FizzyButton({ 
  onClick, 
  href,
  text = 'Launch',
  className = '' 
}: FizzyButtonProps) {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  if (href) {
    return (
      <Link href={href}>
        <motion.span 
          className={`landing-button group relative inline-flex items-center justify-center ${className}`}
          whileHover="hover"
          initial="initial"
          style={{ display: 'inline-flex' }}
        >
          {buttonContent(text, className)}
        </motion.span>
      </Link>
    );
  }

  return (
    <motion.button 
      ref={buttonRef}
      onClick={onClick}
      className={`landing-button group relative ${className}`}
      whileHover="hover"
      initial="initial"
    >
      {buttonContent(text, className)}
    </motion.button>
  );
}

